import React, { useRef } from 'react'
import KMI from './KMI'
import Modal from '../../2_Molecules/Modal/Modal'

interface KMIFormExtraParams {
  language: string;
  year?: string;
  model?: string;
  model_list?: string;
  evFlag?: string;
  source?: string;
  formHeading?: string;
  formImage?: string;
  formDisclaimer?: string;
  formSubmitButtonText?: string;
  isPopUp?: string;
}

interface KMIModalProps {
  formExtraParams: KMIFormExtraParams;
}

const KMIModal: React.FC<KMIModalProps> = ({
  formExtraParams
}) => {
  const { formImage, isPopUp, ...restParams } = formExtraParams;
  const isPopUpBoolean = (isPopUp && isPopUp.toLowerCase() === 'true');
  const modalRef = useRef<HTMLDivElement>(null);

  return (
    <Modal
      className={`mz-kmi-modal ${isPopUpBoolean ? 'mz-popup-modal' : ''}`}
      isDark={true}
      modalRef={modalRef}
    >
      <KMI
        formExtraParams={restParams}
      />
    </Modal>
  )
}

export default KMIModal
